import React from "react";
import { Col, Row } from "reactstrap";
import { H6 } from "../../../../../AbstractElements";


interface ProfileContactProps {
    contact?: string;
    location?: string;
}

const ProfileContact: React.FC<ProfileContactProps> = ({ contact = "N/A", location = "Unknown" }) => {
    return (
         <>
         
        <Col sm={6} xl={4} className="order-sm-2 order-xl-2">
            <Row className="g-3">
                <Col md={6} className="mt-0 mt-sm-3">
                      {/* <div className="ttl-info text-start">
                        <H6>
                            <i className="fa-solid fa-location-arrow" aria-hidden="true" /> Location
                        </H6>
                        <span>{location}</span>
                    </div> */}
                </Col>
                <Col md={6}>

                <div className="ttl-info text-start">
                        <H6>
                            <i className="fa-solid fa-phone" aria-hidden="true" /> Contact
                        </H6>
                        <span>{contact}</span>
                    </div>
                  
                </Col>
            </Row>
        </Col>
        </>
    );
};

export default ProfileContact;
